/**
 * Format integer cents as a German EUR currency string, e.g. 1000 → "10,00 €".
 * No fractional cents, German locale uses "," as decimal separator.
 */
export const formatEuroFromCents = (cents: number): string => {
	const euros = cents / 100;
	return new Intl.NumberFormat('de-DE', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(euros);
};
